/**
 * 🚨 This file is generated using the zendesk script found in https://github.com/LatitudeFinancial/dev-toolbox
 */

export const closeAccountFieldsNZ = {
  Status: { prod: 360013721953, nonProd: "NA" },
  Group: { prod: 360013722013, nonProd: 360004390538 },
  Assignee: { prod: 360013722033, nonProd: 376888316957 },
  Subject: { prod: 360013721913, nonProd: "NA" },
  Description: { prod: 360013721933, nonProd: "NA" },
  "Customers first name": { prod: 360006712378, nonProd: 360010706397 },
  "Surname  (as it appears on ID)": {
    prod: 360026751773,
    nonProd: 360010709557,
  },
  "Relationship to account": { prod: 360006009878, nonProd: 360010669558 },
  "ATP or POA Full Name": { prod: 360006032317, nonProd: 360010667918 },
  DOB: { prod: 360022862154, nonProd: 360010707057 },
  "Mobile Number": { prod: 360006010038, nonProd: 360010707337 },
  "Security question": { prod: 360006239578, nonProd: 360010667978 },
  "Value field": { prod: 360006271557, nonProd: "NA" },
  "Date field": { prod: 360006271577, nonProd: "NA" },
  "Last 4 digits": { prod: 360006081238, nonProd: 360010709017 },
  "Product NZ ": { prod: 360006775857, nonProd: 360010665898 },
  "Outstanding Balance": { prod: 360006176058, nonProd: 360010706357 },
  "Account closure reason": { prod: 360008220777, nonProd: 360010708217 },
  "Other Information": { prod: 360022820474, nonProd: 360010669618 },
  Priority: { prod: 360013721993, nonProd: "NA" },
  Type: { prod: 360013721973, nonProd: "NA" },
  "Email Contact ON FILE": { prod: 360005939057, nonProd: "NA" },
  "Mobile Contact ON FILE": { prod: 360005939037, nonProd: "NA" },
  "Account number ON FILE": { prod: 360004901638, nonProd: "NA" },
  "Product Name ON FILE": { prod: 360005938977, nonProd: "NA" },
  "Account Position ON FILE": { prod: 360005807577, nonProd: "NA" },
  "Manual Input ON FILE": { prod: 360005796038, nonProd: "NA" },
  "Application ID ON FILE": { prod: 360005922518, nonProd: "NA" },
  "Direct debit and insurance cancelled": {
    prod: 360006186078,
    nonProd: 360010668198,
  },
  "Liable for unposted purchases": {
    prod: 360006212717,
    nonProd: 360010668898,
  },
  "Cannot reopen account": { prod: 360006212737, nonProd: 360010670098 },
  "Privacy Acknowledgement": { prod: 360006023478, nonProd: 360010666398 },
  "Time spent last update (sec)": { prod: 360021307894, nonProd: "NA" },
  "Total time spent (sec)": { prod: 360021307874, nonProd: "NA" },
  "Account Holder's Full Name": { prod: 360006010718, nonProd: 360010707817 },
};

export const closeAccountFieldsAU = {
  Status: { prod: 360013721953, nonProd: "NA" },
  Group: { prod: 360013722013, nonProd: 360004390118 },
  Assignee: { prod: 360013722033, nonProd: 376888316957 },
  Subject: { prod: 360013721913, nonProd: "NA" },
  Description: { prod: 360013721933, nonProd: "NA" },
  "Customers first name": { prod: 360006712378, nonProd: 360010706397 },
  "Surname  (as it appears on ID)": {
    prod: 360026751773,
    nonProd: 360010709557,
  },
  "Account Holder's Full Name": { prod: 360006010718, nonProd: 360010707817 },
  "Relationship to account": { prod: 360006009878, nonProd: 360010669558 },
  "ATP or POA Full Name": { prod: 360006032317, nonProd: 360010667918 },
  DOB: { prod: 360022862154, nonProd: 360010707057 },
  "DOB DD/MM/YYYY": { prod: 360006254998, nonProd: 360010666198 },
  "Mobile Number": { prod: 360006010038, nonProd: 360010707337 },
  "Security question": { prod: 360006239578, nonProd: 360010667978 },
  "Value field": { prod: 360006271557, nonProd: "NA" },
  "Date field": { prod: 360006271577, nonProd: "NA" },
  "Last 4 card digits": { prod: 360007275317, nonProd: 360010666158 },
  "Last 4 digits": { prod: 360006081238, nonProd: 360010709017 },
  "Copy required? ": { prod: 360006011578, nonProd: 360010707457 },
  "Latitude Card Type": { prod: 360006076178, nonProd: 360010709097 },
  "Outstanding Balance": { prod: 360006176058, nonProd: 360010706357 },
  "Account closure reason": { prod: 360008220777, nonProd: 360010708217 },
  "Other Information": { prod: 360022820474, nonProd: 360010669618 },
  Priority: { prod: 360013721993, nonProd: "NA" },
  Type: { prod: 360013721973, nonProd: "NA" },
  "Email Contact ON FILE": { prod: 360005939057, nonProd: "NA" },
  "Mobile Contact ON FILE": { prod: 360005939037, nonProd: "NA" },
  "Account number ON FILE": { prod: 360004901638, nonProd: "NA" },
  "Product Name ON FILE": { prod: 360005938977, nonProd: "NA" },
  "Account Position ON FILE": { prod: 360005807577, nonProd: "NA" },
  "Manual Input ON FILE": { prod: 360005796038, nonProd: "NA" },
  "Application ID ON FILE": { prod: 360005922518, nonProd: "NA" },
  Channel: { prod: 360004871878, nonProd: 360010707917 },
  "Direct debit and insurance cancelled": {
    prod: 360006186078,
    nonProd: 360010668198,
  },
  "Liable for unposted purchases": {
    prod: 360006212717,
    nonProd: 360010668898,
  },
  "Cannot reopen account": { prod: 360006212737, nonProd: 360010670098 },
  "Privacy Acknowledgement": { prod: 360006023478, nonProd: 360010666398 },
  "Time spent last update (sec)": { prod: 360021307894, nonProd: "NA" },
  "Total time spent (sec)": { prod: 360021307874, nonProd: "NA" },
  "Latitude Card(s)": { prod: 360006186058, nonProd: 360010706997 },
};

// Both AU and NZ forms have the same values.
// If they start diverging, we'll need to create `reasonOptionValuesAU` and `reasonOptionValuesNZ`.
export const reasonOptionValues = {
  "Fees are too high": {
    prod: "fees_are_too_high",
    nonProd: "fees_are_too_high",
  },
  "Interest is too high": {
    prod: "interest_is_too_high",
    nonProd: "interest_is_too_high",
  },
  "I am not happy with the features of the card (e.g. no rewards points)": {
    prod: "i_am_not_happy_with_the_features_of_the_card__e.g._no_rewards_points_",
    nonProd:
      "i_am_not_happy_with_the_features_of_the_card__e.g._no_rewards_points_",
  },
  "I am applying or refinancing my personal loan or home loan": {
    prod: "i_am_applying_or_refinancing_my_personal_loan_or_home_loan",
    nonProd: "i_am_applying_or_refinancing_my_personal_loan_or_home_loan",
  },
  "I am consolidating my debt/I have too many credit cards": {
    prod: "i_am_consolidating_my_debt/i_have_too_many_credit_cards",
    nonProd: "i_am_consolidating_my_debt/i_have_too_many_credit_cards",
  },
  "I no longer need this card": {
    prod: "i_no_longer_need_this_card",
    nonProd: "i_no_longer_need_this_card",
  },
  "Unhappy with Customer Service/online system": {
    prod: "unhappy_with_customer_service/online_system",
    nonProd: "unhappy_with_customer_service/online_system",
  },
  "Other ": { prod: "other_", nonProd: "other_" },
};

export const nzProducts = {
  "Gem Visa": {
    prod: "gem_visa",
    nonProd: "gem_visa",
  },
  "Gem Essential": {
    prod: "gem_essential",
    nonProd: "gem_essential",
  },
  "Gem CreditLine": {
    prod: "gem_credit_line_",
    nonProd: "gem_credit_line_",
  },
  "Gem Personal Loan": {
    prod: "gem_personal_loan",
    nonProd: "gem_personal_loan",
  },
  "Gem Motor Loan": {
    prod: "gem_car_loan_nz",
    nonProd: "gem_car_loan_nz",
  },
};
